<template>
  <exportTemplate ref="exportTemplate" :formModel="formModel" :table-data="tableList" :summary-data="tableSummaryData" :table-total="paginationTotal" :table-load="tableLoading" @set-custom-columns="setCustomColumns" @close-custom-columns="closeCustomColumns" @pagination-change="paginationChange" @form-submit="formSubmit" @form-reset="formReset" @sort="sortChange" @table-export="tableExport" @row-dblclick="rowDblclick">
    <template #form>
      <el-form-item label="仓库" prop="inWarehouse.selected">
        <select-multiple :select-data="formModel.inWarehouse"></select-multiple>
      </el-form-item>
      <el-form-item label="品牌" prop="financialBrand.selected">
        <select-multiple :select-data="formModel.financialBrand" :isClear="false"></select-multiple>
      </el-form-item>
      <el-form-item label="大类" prop="brand.selected">
        <select-multiple :select-data="formModel.brand" :change="brandChange"></select-multiple>
      </el-form-item>
      <el-form-item label="小类" prop="brandType.selected">
        <select-multiple :select-data="formModel.brandType"></select-multiple>
      </el-form-item>
      <el-form-item label="商品" prop="product.selected">
        <el-select class="select_multiple" ref="productSelectRef" v-model="formModel.product.selected" value-key="value" multiple clearable placeholder="请选择商品名称" @focus="productInputFocus" @change="productChange">
          <el-option v-for="item in formModel.product.list" :key="item.value" :label="item.text" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="stockStatus.selected" style="text-align: center;">
        <el-checkbox v-model="formModel.stockStatus.selected" true-label="" false-label="B">包括库存为0的商品</el-checkbox>
      </el-form-item>
    </template>
    <template>
      <el-table-column label="仓库名" prop="warehouseName" fixed width="150"></el-table-column>
      <el-table-column label="商品名" prop="itemName" fixed width="150"></el-table-column>
      <el-table-column label="类别" prop="brandName" width="150" v-if="customColumnList['brandName']">
        <template #default="{ row }">
          <span>{{ row.brandName }}</span>
          <span style="margin: 0 6px;">/</span>
          <span>{{ row.itemTypeName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="商品编号" prop="itemCode" width="100" v-if="customColumnList['itemCode']"></el-table-column>
      <el-table-column label="商品条码" prop="invBarCode" width="120" v-if="customColumnList['invBarCode']"></el-table-column>
      <el-table-column label="实际库存" prop="onhandQtyUnit" sortable="custom" width="100"></el-table-column>
      <el-table-column label="占用量" prop="orderLoadQty" sortable="custom" width="100"></el-table-column>
      <el-table-column label="可用库存" prop="availableQty" sortable="custom" width="100"></el-table-column>
      <el-table-column label="库存成本" prop="onhandAmt" sortable="custom" width="100" v-if="customColumnList['onhandAmt']"></el-table-column>
      <el-table-column label="库存货值" prop="onHandPrice" sortable="custom" width="100"></el-table-column>
      <el-table-column label="重量" prop="itemWeight" width="100" v-if="customColumnList['itemWeight']"></el-table-column>
    </template>
    <el-dialog title="选择商品" :visible.sync="selectProductVisible" width="1080px" append-to-body :close-on-click-modal="false" custom-class="product-dialog">
      <selectProduct v-if="selectProductVisible" @get-product-data="getProductData" :default-checked-keys="formModel.product.list"></selectProduct>
    </el-dialog>
  </exportTemplate>
</template>

<script>
import exportTemplate from '@/components/common/exportTemplate.vue'
import selectProduct from '@/components/common/selectProduct.vue'
import { getQueryItem, exportExcelCommonForVue } from '@/assets/js/common.js'
export default {
  name: 'mainAccount',
  components: {
    exportTemplate,
    selectProduct
  },
  data() {
    return {
      params: {
        page: 1,
        isMaster: 'N',
        size: 10,
        stockStatus: ''
      },
      formModel: {
        inWarehouse: { submitName: 'warehouseID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll:false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择仓库', request: { url: '/Account/wareHouseDefine/selectWarehouseForVue.html', type: 'post', params: {page: 1, size: 5}, text: '', value: '' }},
        financialBrand: { submitName: 'financialBrandID', valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择品牌', request: { url: 'Account/dataSearch/selectFinanceBrandListForVue.html', type: 'post', params: { page: 1, size: 5, isPage: 'Y' }, text: '', value: '' } },
        brand: { submitName: 'brandID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false,isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择大类', request: { url: '/Account/dataSearch/selectBrandListForVue.html', type: 'post', params: {page: 1, size: 5, isPage: 'Y'}, text: '', value: ''}},
        brandType: { submitName: 'itemTypeID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false,isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择小类', request: { url: '/Account/dataSearch/selectTypeListNewForVue.html', type: 'post', params: {page: 1, size: 5, isPage: 'Y'}, text: '', value: ''}},
        product: { submitName: 'itemID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择商品名称', request: { url: '/Account/itemMasterDefine/selectItemMastForVue.html', type: 'post', params: {page: 1, size: 5}, text: '', value: '' }},
        stockStatus: { submitName: 'stockStatus', selected: '' },
      },
      paginationTotal: 0,
      tableLoading: false,
      tableList: [],
      tableSummaryData: {},
      selectProductVisible: false,
      customColumnsList: [
        {
          label: "类别",
          prop: "brandName"
        },
        {
          label: "商品编号",
          prop: "itemCode"
        },
        {
          label: "商品条码",
          prop: "invBarCode"
        },
        {
          label: "库存成本",
          prop: "onhandAmt",
          power: ['allowCostPrice']
        },
        {
          label: "重量",
          prop: "itemWeight"
        }
      ],
      customColumn: [],
    }
  },
  computed: {
    customColumnList() {
      let tempItem = {}
      this.customColumn.forEach(i => {
        tempItem[i.prop] = (i.isShow == 'Y')
      })
      return tempItem
    }
  },
  created() {
    this.getCustomColumnsList()
    this.getTableList()
  },
  methods: {
    setCustomColumns(el) {
      let tempArr = [...this.customColumn]
      console.log(tempArr)
      el.loading = false
      el.setCustomcolumns(tempArr)
    },
    closeCustomColumns(el) {
      el.$nextTick(async () => {
        let { customColumns } = el
        const { data: res } = await this.$http.post('/Account/customerColumnDefineVue/saveColAndAuthByFuncCode.html', this.Qs.stringify({
          funcCode: 228,
          customSetInfo: JSON.stringify(customColumns)
        }))
        if (res.code != 'success') return this.$message.error(res.message)
        this.$message.success(res.message)
      })
    },
    async getCustomColumnsList() {
      const { data: res } = await this.$http.post(
        "Account/dataSearchVue/selectColumnByFuncCode.html",
        this.Qs.stringify({ funcCode: 228 })
      );
      if (res.code != "success") return this.$confirm(res.message, "提示", {
        confirmButtonText: "确定",
        showCancelButton: false,
        type: "error",
      });
      let result = JSON.parse(res.result);
      let arr = [];
      this.customColumnsList.forEach((item) => {
        result.forEach(($item) => {
          if (item.prop == $item.prop) {
            if (item.power && item.power.length) {
              if (item.power.every((row) => this.$store.state.power[row] == "Y")) {
                arr.push({
                  id: $item.id,
                  label: item.label,
                  prop: item.prop,
                  isShow: $item.isShow,
                });
              }
            } else {
              arr.push({
                id: $item.id,
                label: item.label,
                prop: item.prop,
                isShow: $item.isShow,
              });
            }
          }
        });
      });
      this.customColumn = [...arr]
    },
    productChange(val) {
        this.formModel.product.list = val
    },
    paginationChange({page, size, isGetTable = true}) {
      this.params.page = page
      this.params.size = size
      if (isGetTable) {
        this.getTableList()
      }
    },
    formSubmit() {
      this.params = { ...this.params, ...getQueryItem(this.formModel) }
      this.getTableList()
    },
    formReset() {
      this.params['sortField'] = ''
      this.params['softBy'] = ''
      this.params.page = 1
    },
    async getTableList() {
      this.tableLoading = true
      this.tableData = []
      const { data: res } = await this.$post(
        "/erpnew/account/c/reada46ceb/invItemMaster/selectselectInvItemMasterList.html",
        this.params
      )
      this.tableLoading = false
      if (res.code != '0') return this.$message.error(res.message)
      let { data, sum, total } = res.data
      this.paginationTotal = total
      this.tableSummaryData = sum
      this.tableList = data
    },
    sortChange({ sortField, sortBy }) {
      this.params['sortField'] = sortField
      this.params['sortBy'] = sortBy
      this.params.page = 1
      this.getTableList()
    },
    tableExport(tabColumn) {
      exportExcelCommonForVue(this.params, tabColumn, '/erpnew/account/c/reada46ceb/invItemMaster/queryInvItemMasterListExcelReport.html')
      console.log(tabColumn)
    },
    productInputFocus() {
      this.$refs['productSelectRef'].blur()
      this.selectProductVisible = true
    },
    getProductData(data) {
      this.selectProductVisible = false
      this.formModel.product.selected = data
      this.formModel.product.list = data
    },
    rowDblclick({ row }) {
      console.log(row);
      let options = this.Qs.stringify({
        item: { text: row.itemName, value: row.itemID },
        // warehouse: { text: row.warehouseName, value: row.warehouseID }
      })
      let url = `/templates/vue-account/dist/index.htm#/dataSearchStockMainAccountDetailed?${options}`
      this.$refs.exportTemplate.toJump('库存明细', url)
    },
    brandChange(val) {
      let str = val.map(item => "'" + item.value + "'").join(',')
      this.formModel.brandType.request.params['brandID'] = str
      this.formModel.brandType.isReSearch = true
    }
  }
}
</script>

<style lang="less" scoped>
</style>